import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import { AuthProvider } from "./lib/api.jsx";
import { applyTheme } from "./theme/applyTheme.js";
import "./index.css";

applyTheme(); // sets --color-*, --type-*, --space-* etc. from theme/tokens.js before first paint

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
